import { lazy, Suspense } from 'react'
import cls from './FullscreenDialog.module.scss'

const FullscreenDialogImplementation = lazy(() =>
    import('./ui/FullscreenDialog').then((module) => ({
        default: module.FullscreenDialog,
    }))
)

export const FullscreenDialog = (props) => (
    <Suspense fallback={<div aria-hidden="true" className={cls.Fallback} />}>
        <FullscreenDialogImplementation {...props} />
    </Suspense>
)
